/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as sis from './SISApp'
import { componentApi, loadTranslations } from 'common'


export class K12HallpassStudentrestrictionsApi {
  async LoadData(ssyGU : string) : Promise<sis.StudentHallPassRestrictionsData> {
    return await componentApi.call('sis', 'k12-hallpass-studentrestrictions', 'K12HallpassStudentrestrictionsApi', 'LoadData', {
      ssyGU,
    });
  }
}
export default new K12HallpassStudentrestrictionsApi()
